module.exports = __webpack_public_path__ + "img/10_fineStaff_gt.c73f5f6c.png";